const state = {
    logs: []
};

const mutations = {
    ADD_ERROR_LOG: (state, log) => {
        if(state.logs.length > 100) {
            state.logs.unshift(log);
            state.logs = state.logs.slice(0, 100);
        }else {
            state.logs.unshift(log);
        }
    },
    CLEAR_ERROR_LOG: (state) => {
        state.logs.splice(0);
    }
};

const actions = {
    addErrorLog({ commit }, log) {
        commit('ADD_ERROR_LOG', log);
    },
    clearErrorLog({ commit }) {
        commit('CLEAR_ERROR_LOG');
    }
};

export default {
    state,
    mutations,
    actions
};
